import {BaseGeofenceSiteGroupSelect, BaseGeofenceSiteGroupSelectProps} from "./BaseGeofenceSiteGroupSelect";
import {useMemo} from "react";
import {
  GeofenceSiteGroupSelectorProps,
  geofenceSiteGroupsSelector,
  useGetAllGeofenceSiteGroupsQuery
} from "@ots-frontend/ots-data";

export type GeofenceSiteGroupSelectProps = Omit<BaseGeofenceSiteGroupSelectProps, "entities" | "loading"> & {
  selector?: GeofenceSiteGroupSelectorProps
}

export const GeofenceSiteGroupSelect = (props: GeofenceSiteGroupSelectProps) => {
  const {selector, ...rest} = props;

  const selectGeofenceSiteGroups = useMemo(() => {
    return geofenceSiteGroupsSelector();
  }, []);

  const {geofenceSiteGroups, isLoading} = useGetAllGeofenceSiteGroupsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      geofenceSiteGroups: selectGeofenceSiteGroups(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseGeofenceSiteGroupSelect entities={geofenceSiteGroups} loading={isLoading} {...rest} />;
};
